// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-widget{height:100%}.image-widget img{width:100%}`, "",{"version":3,"sources":["webpack://./../common/dist/widgets/image-widget/image-widget.scss"],"names":[],"mappings":"AAAA,cAAc,WAAW,CAAC,kBAAkB,UAAU","sourcesContent":[".image-widget{height:100%}.image-widget img{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
